import { AuthFlowPage } from '../components/AuthFlowPage'

export default function RegisterPage() {
  return <AuthFlowPage kind="registration" />
}
